import type { Locale } from "./config";

export function detectLocale(languages: readonly string[]): Locale {
  const preferred = languages.find((language) => language.trim().length > 0);
  return preferred?.toLowerCase().startsWith("de") ? "de" : "en";
}

export function alternateLocale(locale: Locale): Locale {
  return locale === "en" ? "de" : "en";
}

export function buildMailto(
  recipient: string,
  subject: string,
): string {
  return "mailto:" + recipient + "?subject=" + encodeURIComponent(subject);
}
